export const isInternalOffice = (officeType?: string): boolean =>
  officeType === "UAE_OFFICE" || officeType === "RUSSIAN_TEST_OFFICE" || officeType === "CHINESE_TEST_OFFICE";
